import { render, staticRenderFns } from "./StartDetection.vue?vue&type=template&id=2255ba0d&scoped=true&"
import script from "./StartDetection.vue?vue&type=script&lang=js&"
export * from "./StartDetection.vue?vue&type=script&lang=js&"
import style0 from "./StartDetection.vue?vue&type=style&index=0&id=2255ba0d&prod&lang=css&"
import style1 from "./StartDetection.vue?vue&type=style&index=1&id=2255ba0d&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2255ba0d",
  null
  
)

export default component.exports